import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import './App.css';

const STATIC_USERS = [
  { id: '1000535281', name: 'Ксюша' },
  { id: '1463996', name: 'Дима' },
  { id: '1000826737', name: 'Коля' },
  { id: '740025', name: 'Лёша' },
  { id: '163673', name: 'Арнольд' },
  { id: '2001', name: 'Анна' },
  { id: '2002', name: 'Михаил' },
  { id: '2003', name: 'Елена' },
  { id: '2004', name: 'Ольга' },
  { id: '2005', name: 'Сергей' },
  { id: '2006', name: 'Наталья' },
  { id: '2007', name: 'Андрей' },
  { id: '2008', name: 'Татьяна' },
];

const GENDERS = [
  { id: 'female', label: 'ЖЕНСКОЕ' },
  { id: 'male', label: 'МУЖСКОЕ' },
  { id: 'kids', label: 'ДЕТСКОЕ' },
];

const SEGMENTS = ['low', 'medium', 'high+'];
const TOP_BRAND_CHIPS = 14;

const fmtPrice = (p) => {
  if (!p || p <= 0) return '—';
  return Math.round(p).toLocaleString('ru-RU').replace(/,/g, ' ') + ' ₽';
};

function pluralize(n) {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return 'товар';
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return 'товара';
  return 'товаров';
}

function extractPhoto(p) {
  const pa = p.photo_analytics;
  if (!pa) return null;
  if (typeof pa === 'string') return pa;
  if (Array.isArray(pa)) {
    const first = pa[0];
    if (typeof first === 'string') return first;
    if (first && typeof first === 'object') {
      return first.w1000 || first.w500 || first.w2000 || first.w200x2 || first.w200 || first.url || null;
    }
  }
  if (typeof pa === 'object') {
    if (pa.w1000 || pa.w500 || pa.w2000) return pa.w1000 || pa.w500 || pa.w2000;
    if (pa.url) return pa.url;
    const flat = JSON.stringify(pa).match(/https?:\/\/[^"',}\s]+/);
    if (flat) return flat[0];
  }
  return null;
}

function RatingModal({ onClose, context }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!rating) return;
    setBusy(true);
    try {
      await axios.post('/api/ratings', { rating, comment, context });
      setSent(true);
      setTimeout(onClose, 1200);
    } catch (e) {
      alert('Ошибка отправки: ' + (e.response?.data?.error || e.message));
      setBusy(false);
    }
  };

  return (
    <>
      <div className="backdrop open" onClick={onClose} />
      <div className="rating-modal" onClick={(e) => e.stopPropagation()} role="dialog">
        <button className="close" onClick={onClose}>×</button>
        {sent ? (
          <div className="rating-thanks">Спасибо! Оценка сохранена.</div>
        ) : (
          <>
            <h3>Оцените результат поиска</h3>
            <div className="rating-meta">
              Запрос: <b>{context.q || '—'}</b>{context.gender ? ` · ${context.gender}` : ''}
            </div>
            <div className="rating-row">
              {[1, 2, 3, 4, 5].map((n) => (
                <button
                  key={n}
                  type="button"
                  className={'rating-btn' + (rating === n ? ' active' : '')}
                  onClick={() => setRating(n)}
                >{n}</button>
              ))}
            </div>
            {rating > 0 && rating < 5 && (
              <textarea
                className="rating-comment"
                placeholder="Что не так?"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                autoFocus
              />
            )}
            <button className="rating-submit" disabled={!rating || busy} onClick={submit}>
              {busy ? 'Отправка…' : 'Отправить'}
            </button>
          </>
        )}
      </div>
    </>
  );
}

function Card({ product, showMeta }) {
  const img = extractPhoto(product);
  const price = product.price_with_discount || product.price;
  const stage = product.fallback_stage || 'none';
  const src = product.retrieval_source || '—';
  return (
    <div className="card">
      <div className="img-wrap">
        {img ? (
          <img src={img} alt={product.title || ''} loading="lazy" onError={(e) => { e.target.style.display = 'none'; }} />
        ) : (
          <div className="img-empty">нет фото</div>
        )}
        <div className="star">☆</div>
      </div>
      <div className="vendor" title={product.brand_title || ''}>{product.brand_title || '—'}</div>
      <div className="name" title={product.title || ''}>{product.title || ''}</div>
      <div className="price">{fmtPrice(price)}</div>
      {showMeta && (
        <div className="meta-tags">
          <span className={'meta-tag stage stage-' + stage}>{stage}</span>
          <span className="meta-tag src">{src}</span>
        </div>
      )}
    </div>
  );
}

function readInitial() {
  const u = new URLSearchParams(window.location.search);
  const userId = u.get('user') || '';
  const userObj = userId ? (STATIC_USERS.find((x) => x.id === userId) || { id: userId, name: 'ручной' }) : null;
  const seg = (u.get('segment') || '').split(',').filter(Boolean).filter((s) => SEGMENTS.includes(s));
  const validGenders = ['male', 'female', 'kids'];
  const g = u.get('gender');
  const parseBool = (v, def) => v === null || v === undefined ? def : (v === '1' || v === 'true');
  return {
    query: u.get('q') || '',
    gender: validGenders.includes(g) ? g : 'male',
    user: userObj,
    rerank: u.get('rerank') === '1' || u.get('rerank') === 'true' || !!userObj,
    segment: new Set(seg),
    boost_current_season: parseBool(u.get('boost'), true),
    segment_as_rerank: parseBool(u.get('sar'), true),
  };
}

function App() {
  const initial = readInitial();
  const [query, setQuery] = useState(initial.query);
  const [submittedQuery, setSubmittedQuery] = useState('');
  const [gender, setGender] = useState(initial.gender);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);

  const [brandFilter, setBF] = useState(new Set());
  const [categoryFilter, setCF] = useState(new Set());

  const [drawerOpen, setDrawer] = useState(false);
  const [brandPop, setBrandPop] = useState(false);
  const [brandSearch, setBSearch] = useState('');
  const [ratingOpen, setRatingOpen] = useState(false);

  const [selectedUser, setSelectedUser] = useState(initial.user);
  const [manualId, setManualId] = useState('');

  const [settings, setSettings] = useState({
    rerank: initial.rerank,
    boost_current_season: initial.boost_current_season,
    segment_as_rerank: initial.segment_as_rerank,
    segment: initial.segment,
    limit: 2000,
    show_meta: false,
  });

  const [hideHeader, setHideHeader] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    if (!headerRef.current) return;
    const el = headerRef.current;
    const update = () => {
      const h = el.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-h', h + 'px');
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener('resize', update);
    return () => { ro.disconnect(); window.removeEventListener('resize', update); };
  }, []);

  useEffect(() => {
    let last = window.scrollY;
    let lastDir = '';
    let frame = 0;
    const loop = () => {
      const y = window.scrollY;
      if (y !== last) {
        if (y < 40) { if (lastDir !== 'show') { setHideHeader(false); lastDir = 'show'; } }
        else if (y < last) { if (lastDir !== 'show') { setHideHeader(false); lastDir = 'show'; } }
        else if (y > last) { if (lastDir !== 'hide') { setHideHeader(true); lastDir = 'hide'; } }
        last = y;
      }
      frame = requestAnimationFrame(loop);
    };
    frame = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(frame);
  }, []);

  const syncUrl = (q, g, user, rerank, segSet, flags) => {
    const u = new URLSearchParams();
    if (q) u.set('q', q);
    if (g) u.set('gender', g);
    if (user?.id) u.set('user', user.id);
    if (rerank) u.set('rerank', '1');
    const segArr = [...segSet];
    if (segArr.length) u.set('segment', segArr.join(','));
    if (flags && flags.boost_current_season === false) u.set('boost', '0');
    if (flags && flags.segment_as_rerank === false) u.set('sar', '0');
    const qs = u.toString();
    const next = qs ? `?${qs}` : window.location.pathname;
    window.history.replaceState(null, '', next);
  };

  const doSearch = async (q, g = gender, userOverride, rerankOverride, segOverride, flagsOverride) => {
    if (!q || !q.trim()) return;
    setLoading(true);
    setError(null);
    setBF(new Set());
    setCF(new Set());
    setSubmittedQuery(q);
    const user = userOverride !== undefined ? userOverride : (manualId ? { id: manualId, name: 'ручной' } : selectedUser);
    const forcedRerank = !!user || (rerankOverride !== undefined ? rerankOverride : settings.rerank);
    const seg = segOverride || settings.segment;
    const flags = {
      boost_current_season: settings.boost_current_season,
      segment_as_rerank: settings.segment_as_rerank,
      ...(flagsOverride || {}),
    };
    syncUrl(q, g, user, forcedRerank, seg, flags);
    try {
      const params = {
        q,
        limit: settings.limit || 60,
        rerank: forcedRerank,
        boost_current_season: flags.boost_current_season,
        segment_as_rerank: flags.segment_as_rerank,
      };
      if (g) params.gender = g;
      const segArr = [...seg];
      if (segArr.length) params.segment = segArr;
      if (user?.id) params.np_client_id = user.id;

      const r = await axios.get('/api/search', { params });
      setResults(r.data);
    } catch (e) {
      setError(e.response?.data?.error || e.message);
      setResults(null);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = (e) => { e?.preventDefault(); doSearch(query); };
  const onGender = (g) => { setGender(g); if (submittedQuery || initial.query) doSearch(submittedQuery || initial.query, g); };

  // auto-run from URL
  const didInitialRef = useRef(false);
  useEffect(() => {
    if (didInitialRef.current) return;
    didInitialRef.current = true;
    if (initial.query) doSearch(initial.query, initial.gender, initial.user, initial.rerank, initial.segment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const products = results?.products || [];

  const allBrands = useMemo(() => {
    const c = {};
    for (const p of products) {
      const v = p.brand_title || '';
      if (v) c[v] = (c[v] || 0) + 1;
    }
    return Object.entries(c).sort((a, b) => b[1] - a[1]);
  }, [products]);

  const allCategories = useMemo(() => {
    const c = {};
    for (const p of products) {
      const list = [p.category_3, p.category_2, p.category_1].find((x) => Array.isArray(x) && x.length);
      if (list) for (const cat of list) c[cat] = (c[cat] || 0) + 1;
    }
    return Object.entries(c).sort((a, b) => b[1] - a[1]);
  }, [products]);

  const matchesCategory = (p) => {
    if (categoryFilter.size === 0) return true;
    const all = [
      ...(p.category_1 || []), ...(p.category_2 || []), ...(p.category_3 || []),
      ...(p.category_4 || []), ...(p.category_5 || []),
    ];
    for (const c of all) if (categoryFilter.has(c)) return true;
    return false;
  };

  const filtered = useMemo(() => products.filter((p) => {
    if (brandFilter.size > 0 && !brandFilter.has(p.brand_title)) return false;
    if (!matchesCategory(p)) return false;
    return true;
  }), [products, brandFilter, categoryFilter]);

  // Точка разреза = первый «фолбек»-товар в (уже отсортированном) списке.
  // Правило по fallback_stage (retrieval_source не учитываем):
  // 1) Если есть товары со stage === 'none' — главные ровно они; всё остальное в фолбек.
  // 2) Иначе главные = fuzzy-префикс; глубокие фолбеки (brand_*, category_*) ниже.
  // 3) Если ни none, ни fuzzy — всё в фолбек, дисклеймер сверху.
  const isNoneStage = (p) => !p.fallback_stage || p.fallback_stage === 'none';
  const hasNone = filtered.some(isNoneStage);
  const isFallback = (p) => {
    if (hasNone) return !isNoneStage(p);
    return !isNoneStage(p) && p.fallback_stage !== 'fallback_semantic_fuzzy';
  };
  const splitAt = filtered.findIndex(isFallback);
  const mainProducts = splitAt === -1 ? filtered : filtered.slice(0, splitAt);
  const fallbackProducts = splitAt === -1 ? [] : filtered.slice(splitAt);

  const toggle = (setter, val) => setter((prev) => {
    const next = new Set(prev);
    if (next.has(val)) next.delete(val); else next.add(val);
    return next;
  });

  const topBrandChips = allBrands.slice(0, TOP_BRAND_CHIPS);
  const filteredBrands = allBrands.filter(([b]) => b.toLowerCase().includes(brandSearch.toLowerCase()));
  const filtersActive = brandFilter.size + categoryFilter.size > 0;

  const applyManual = () => {
    const v = manualId.trim();
    if (v) {
      const u = { id: v, name: 'ручной' };
      setSelectedUser(u);
      setSettings((s) => ({ ...s, rerank: true }));
      setDrawer(false);
      if (submittedQuery) doSearch(submittedQuery, gender, u, true);
    }
  };

  const title = submittedQuery ? `Поиск: ${submittedQuery}` : 'Поиск ЦУМ';
  const subTitle = selectedUser ? `${selectedUser.name} · ${selectedUser.id}` : '';

  return (
    <div>
      <div ref={headerRef} className={'sticky-header' + (hideHeader ? ' hidden' : '')}>
        <div className="header-inner">
        <div className="topbar">
          <button className="icon-btn" onClick={() => setDrawer(true)} aria-label="menu">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <line x1="4" y1="7" x2="20" y2="7" />
              <line x1="4" y1="12" x2="20" y2="12" />
              <line x1="4" y1="17" x2="20" y2="17" />
            </svg>
          </button>
          <div className="topbar-title">
            {title}
            {subTitle && <span className="current-user">{subTitle}</span>}
          </div>
          <button className="icon-btn" onClick={() => setDrawer(true)} aria-label="settings">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </button>
        </div>

        <form className="search-row" onSubmit={onSubmit}>
          <input
            placeholder="Найти товары…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit" disabled={loading || !query.trim()}>
            {loading ? '…' : 'Искать'}
          </button>
        </form>

        <div className="gender-row">
          {GENDERS.map((g) => (
            <button
              key={g.id}
              className={'gender-pill' + (g.id === gender ? ' active' : '')}
              onClick={() => onGender(g.id)}
            >
              {g.label}
            </button>
          ))}
        </div>

        {results && allCategories.length > 0 && (
          <div className="strip">
            <span className="strip-label">Категории</span>
            {allCategories.map(([cat, n]) => (
              <button
                key={cat}
                className={'chip' + (categoryFilter.has(cat) ? ' active' : '')}
                onClick={() => toggle(setCF, cat)}
              >
                {cat}<span className="count">{n}</span>
              </button>
            ))}
          </div>
        )}
        {results && allBrands.length > 0 && (
          <div className="strip">
            <span className="strip-label">Бренды</span>
            {topBrandChips.map(([b, n]) => (
              <button
                key={b}
                className={'chip brand' + (brandFilter.has(b) ? ' active' : '')}
                onClick={() => toggle(setBF, b)}
              >
                {b}<span className="count">{n}</span>
              </button>
            ))}
            {allBrands.length > TOP_BRAND_CHIPS && (
              <button className="chip more" onClick={() => setBrandPop(true)}>
                Все бренды{brandFilter.size > 0 ? ` · ${brandFilter.size}` : ''}
              </button>
            )}
          </div>
        )}
        </div>
      </div>

      <div className={'backdrop' + (drawerOpen ? ' open' : '')} onClick={() => setDrawer(false)} />
      <aside className={'drawer' + (drawerOpen ? ' open' : '')} aria-hidden={!drawerOpen}>
        <button className="drawer-close" onClick={() => setDrawer(false)} aria-label="close">×</button>
        <h3>Клиент (np_client_id)</h3>
        <div className="preset-list">
          <button
            className={'preset-btn' + (!selectedUser ? ' active' : '')}
            onClick={() => {
              setSelectedUser(null); setManualId(''); setDrawer(false);
              if (submittedQuery) doSearch(submittedQuery, gender, null);
            }}
          >
            <span>— не выбран —</span><small></small>
          </button>
          {STATIC_USERS.map((u) => (
            <button
              key={u.id}
              className={'preset-btn' + (selectedUser?.id === u.id ? ' active' : '')}
              onClick={() => {
                setSelectedUser(u); setManualId(''); setDrawer(false);
                setSettings((s) => ({ ...s, rerank: true }));
                if (submittedQuery) doSearch(submittedQuery, gender, u, true);
              }}
            >
              <span>{u.name}</span><small>{u.id}</small>
            </button>
          ))}
        </div>
        <h3>ID вручную</h3>
        <div className="manual-row">
          <input
            placeholder="np_client_id"
            value={manualId}
            onChange={(e) => setManualId(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && applyManual()}
          />
          <button onClick={applyManual}>OK</button>
        </div>

        <h3>Ранкинги</h3>
        <div className="toggle-row">
          <label title={selectedUser ? 'Принудительно включён, потому что выбран клиент' : ''}>
            <input
              type="checkbox"
              checked={settings.rerank || !!selectedUser}
              disabled={!!selectedUser}
              onChange={(e) => {
                const v = e.target.checked;
                setSettings((s) => ({ ...s, rerank: v }));
                if (submittedQuery) doSearch(submittedQuery, gender, undefined, v);
              }}
            />rerank{selectedUser ? ' (вкл)' : ''}
          </label>
          <label>
            <input
              type="checkbox"
              checked={settings.boost_current_season}
              onChange={(e) => {
                const v = e.target.checked;
                setSettings((s) => ({ ...s, boost_current_season: v }));
                if (submittedQuery) doSearch(submittedQuery, gender, undefined, undefined, undefined, { boost_current_season: v });
              }}
            />boost_current_season
          </label>
          <label>
            <input
              type="checkbox"
              checked={settings.segment_as_rerank}
              onChange={(e) => {
                const v = e.target.checked;
                setSettings((s) => ({ ...s, segment_as_rerank: v }));
                if (submittedQuery) doSearch(submittedQuery, gender, undefined, undefined, undefined, { segment_as_rerank: v });
              }}
            />segment_as_rerank
          </label>
        </div>

        <h3>Сегмент цены</h3>
        <div className="toggle-row">
          {SEGMENTS.map((s) => (
            <label key={s}>
              <input
                type="checkbox"
                checked={settings.segment.has(s)}
                onChange={() => {
                  const next = new Set(settings.segment);
                  if (next.has(s)) next.delete(s); else next.add(s);
                  setSettings((st) => ({ ...st, segment: next }));
                  if (submittedQuery) doSearch(submittedQuery, gender, undefined, undefined, next);
                }}
              />{s}
            </label>
          ))}
        </div>

        <h3>Лимит выдачи</h3>
        <div className="manual-row">
          <input type="number" value={settings.limit} onChange={(e) => setSettings((s) => ({ ...s, limit: e.target.value }))} />
        </div>

        <h3>Отображение</h3>
        <div className="toggle-row">
          <label>
            <input
              type="checkbox"
              checked={settings.show_meta}
              onChange={(e) => setSettings((s) => ({ ...s, show_meta: e.target.checked }))}
            />показывать тех. метки на товарах
          </label>
        </div>
      </aside>

      {brandPop && (
        <>
          <div className="backdrop open" onClick={() => setBrandPop(false)} />
          <div className="brand-popover" onClick={(e) => e.stopPropagation()} role="dialog">
            <div className="brand-popover-head">
              <h3>Бренды</h3>
              <button className="close" onClick={() => setBrandPop(false)}>×</button>
            </div>
            <div className="brand-popover-search">
              <input placeholder="Поиск бренда..." value={brandSearch} onChange={(e) => setBSearch(e.target.value)} autoFocus />
            </div>
            <div className="brand-list">
              {filteredBrands.map(([b, n]) => (
                <label key={b} className="brand-item">
                  <input type="checkbox" checked={brandFilter.has(b)} onChange={() => toggle(setBF, b)} />
                  <span className="b-name">{b}</span>
                  <span className="count">{n}</span>
                </label>
              ))}
              {filteredBrands.length === 0 && <div style={{ padding: 16, color: '#888', textAlign: 'center' }}>Ничего не найдено</div>}
            </div>
            <div className="brand-popover-foot">
              <button onClick={() => { setBF(new Set()); setBSearch(''); }}>Сбросить</button>
              <button className="apply" onClick={() => setBrandPop(false)}>Готово</button>
            </div>
          </div>
        </>
      )}

      <div className="content">
        <div className="count-row">
          {loading ? 'Загрузка…' :
            error ? <span style={{ color: '#c00' }}>Ошибка: {String(error)}</span> :
              !results ? 'Введите запрос для поиска' :
                <>
                  {filtered.length} {pluralize(filtered.length)}
                  {filtersActive && (
                    <button className="clear-link" onClick={() => { setBF(new Set()); setCF(new Set()); }}>сбросить</button>
                  )}
                </>}
        </div>

        {!loading && !error && results && filtered.length === 0 && (
          <div className="status">Ничего не найдено по запросу «{submittedQuery}»</div>
        )}

        {!loading && !error && results && mainProducts.length === 0 && fallbackProducts.length > 0 && (
          <div className="divider-text">
            Мы ничего не нашли по запросу «{submittedQuery}», измените запрос или посмотрите похожие товары
          </div>
        )}

        {!loading && !error && mainProducts.length > 0 && (
          <div className="grid">
            {mainProducts.map((p, i) => (
              <Card key={`m-${p.product_id}-${i}`} product={p} showMeta={settings.show_meta} />
            ))}
          </div>
        )}

        {!loading && !error && mainProducts.length > 0 && fallbackProducts.length > 0 && (
          <div className="divider-text">
            Это всё, что мы нашли по запросу «{submittedQuery}», посмотрите похожие товары
          </div>
        )}

        {!loading && !error && fallbackProducts.length > 0 && (
          <div className="grid">
            {fallbackProducts.map((p, i) => (
              <Card key={`f-${p.product_id}-${i}`} product={p} showMeta={settings.show_meta} />
            ))}
          </div>
        )}
      </div>

      {submittedQuery && !ratingOpen && (
        <button className="fab" onClick={() => setRatingOpen(true)} title="Оценить выдачу">
          <span className="fab-star">★</span><span className="fab-label">Оценка</span>
        </button>
      )}

      {ratingOpen && (
        <RatingModal
          onClose={() => setRatingOpen(false)}
          context={{
            q: submittedQuery,
            gender,
            segment: [...settings.segment],
            rerank: settings.rerank || !!selectedUser,
            boost_current_season: settings.boost_current_season,
            segment_as_rerank: settings.segment_as_rerank,
            np_client_id: selectedUser?.id || manualId || null,
            price_min: settings.price_min || null,
            price_max: settings.price_max || null,
          }}
        />
      )}
    </div>
  );
}

export default App;
